import React from 'react';
import './DoctorPerfil.css';
import drGonzalo from '../assets/images/dr-gonzalo.png';
import logoUA from '../assets/images/logo-ua.png';
import logoFinis from '../assets/images/logo-finis.png';
import logoUChile from '../assets/images/logo-uchile.png';
import logoCatolica from '../assets/images/logo-catolica.png';
import logoZimmer from '../assets/images/logo-zimmer.png';
import logoUcam from '../assets/images/logo-ucam.png';

const DoctorGonzalo = () => {
  return (
    <div className="doctor-perfil">
      <div className="container">
        <div className="perfil-header">
          <div className="perfil-info">
            <div className="perfil-imagen">
              <img src={drGonzalo} alt="Dr. Gonzalo Varela" />
            </div>
            <div className="perfil-datos-container">
              <div className="perfil-datos">
                <h1>Dr. Gonzalo Varela</h1>
                <p className="experiencia">12 años de experiencia</p>
                <p className="registro">N° reg. 199880</p>
              </div>
              <div className="formacion-lista">
                <div className="formacion-item">
                  <img src={logoUA} alt="UA" />
                  <div className="formacion-texto">
                    <p>Cirujano Dentista</p>
                    <p>- Univ. Antofagasta (2012)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoFinis} alt="Finis Terrae" />
                  <div className="formacion-texto">
                    <p>Especialista en Imagenología</p>
                    <p>Oral y Maxilofacial</p>
                    <p>- Univ. Finis Terrae (2015)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoUChile} alt="Universidad de Chile" />
                  <div className="formacion-texto">
                    <p>Especialista en Implantología</p>
                    <p>Buco Maxilofacial</p>
                    <p>- Univ. Chile (2016)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoCatolica} alt="Universidad Católica" />
                  <div className="formacion-texto">
                    <p>Diplomado de Sedación Consciente</p>
                    <p>- Univ. Católica Chile (2017)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoZimmer} alt="Zimmer" />
                  <div className="formacion-texto">
                    <p>Postitulo Instituto Zimmer</p>
                    <p>- Miami, USA (2024)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoUcam} alt="UCAM" />
                  <div className="formacion-texto">
                    <p>Postitulo "Paciente Virtual Dinámico"</p>
                    <p>- UCAM España (2025)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorGonzalo; 